export const GET_TRIAL_LICENSE_NEURALINK_LOCALSTORAGE_KEY = 'show-trial-neuralink-alert';
export const GET_BUY_LICENSE_NEURALINK_LOCALSTORAGE_KEY = 'show-buy-license-neuralink-alert';
